<!--
  -  Filename........: DateSelector.vue
  -  Project.........: heilpferde-elearning
  -  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
  -  @version........: 1.0
  -
  -  @since..........: 23.06.20, 09:35
  -  @author.........: Robin Rick
  -
  -  @brief..........:
  -->

<template>
    <div class="card mb-3 mt-4">
        <div class="card-header">
            <h4>Kurs-Termine</h4>
        </div>
        <div class="card-body">
            <div class="card-block">
                <p class="card-text">
                    Bitten wählen Sie den Termin oder Zeitraum aus, in dem du den Kurs besuchen möchtest:
                </p>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <label class="input-group-text" for="course_date_id">
                            Termin:
                        </label>
                    </div>
                    <select id="course_date_id" class="form-control" name="course_date_id" v-model="selectedDateId">
                        <option value="placeholder" disabled>
                            Wählen Sie den gewünschten Termin / Zeitraum aus.
                        </option>
                        <option v-for="date in bookableDates" :value="date.id">
                            {{date.title}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DatePicker",
        props: {
            bookableDates: Array
        },
        data() {
            return {
                selectedDateId: 'placeholder'
            }
        }
    }
</script>

<style scoped>

</style>
